module.exports = __webpack_public_path__ + "widgets/ovaem-categories-sub.php";